export interface WymhDownloadLinks {
  android: string;
  ios: string;
  harmonyos: string;
  windows: string;
}

export interface WymhSiteConfig {
  brand: string;
  domain: string;
  domainUrl: string;
  contactEmail: string;
  downloadLinks: WymhDownloadLinks;
}

export const wymhDefaultConfig: WymhSiteConfig = {
  brand: "五一漫画",
  domain: "wuyicomic.com",
  domainUrl: "http://www.wuyicomic.com",
  contactEmail: "txby666666@163.com",
  downloadLinks: {
    android: "https://www.wuyicomic.com",
    ios: "https://www.wuyicomic.com",
    harmonyos: "https://www.wuyicomic.com",
    windows: "https://www.wuyicomic.com",
  },
};